/**
 * Canonical subscription contract (Phase 0 gate).
 * Keep enums aligned with Cloud Functions validation in functions/index.js.
 */
export const VALID_PLAN_IDS = ['starter', 'basic', 'pro', 'enterprise', 'max'];
export const VALID_STATUSES = ['active', 'inactive', 'cancelled', 'suspended', 'trial'];
export const VALID_BILLING = ['monthly', 'yearly', 'lifetime'];

/** Server sets these from the authenticated admin; never send on PATCH. */
export const SERVER_MANAGED_SUBSCRIPTION_FIELDS = ['updated_by', 'updated_at', 'created_by', 'created_at', 'version'];

/** Allowed keys for PATCH-style admin subscription updates (must match functions/index.js SUBSCRIPTION_PATCH_KEYS). */
export const SUBSCRIPTION_PATCH_BODY_KEYS = new Set([
  'planId',
  'planName',
  'price',
  'currency',
  'billing',
  'status',
  'limits',
  'customLimits',
  'hasCustomEntitlement',
  'expectedVersion',
  'idempotency_key',
  'clientTimestamp'
]);

/** Wrapper keys for full document merge writes (must match validateFullMergePayload in functions/index.js). */
export const SUBSCRIPTION_FULL_MERGE_BODY_KEYS = new Set([
  'write_mode',
  'document',
  'expectedVersion',
  'idempotency_key'
]);

export function assertNoExtraKeys(body, allowedSet) {
  if (!body || typeof body !== 'object') return { ok: true };
  const extras = Object.keys(body).filter((k) => !allowedSet.has(k));
  if (extras.length) {
    return { ok: false, errors: [`Unknown fields not allowed: ${extras.join(', ')}`] };
  }
  return { ok: true };
}
